export default __webpack_public_path__ + "static/media/afa.5790af07.png";